export const API_CALLS_TABS = {
    SUBSCRIPTION: {
        name: 'subscription',
        caption: 'Subscription',
    },
    PAY_PER_CALL: {
        name: 'pay-per-call',
        caption: 'Pay per call',
    },
    INTEGRATION: {
        name: 'integration',
        caption: 'Integration',
    },
};
